import { Flex, Link, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { CopyButton } from "@/molecules/CopyButton"
import { Heading } from "@/molecules/Heading"

import styles from "./SelfHostedUser.module.scss"

import type { SelfHostedUserProps } from "."

export const SelfHostedUser = (props: SelfHostedUserProps) => {
  const { url } = props
  const id = "content-self-hosted-user-message-ks"
  const { t } = useTranslation("translation", {
    keyPrefix: "selfHosted.modal"
  })
  const { t: tGeneral } = useTranslation()

  return (
    <Flex vertical gap={14}>
      <Flex vertical>
        <Heading level={6} title={t("almostFinished")} />
        <Text>{t("shareMessage")}</Text>
      </Flex>
      <Flex vertical gap={12} className={styles.wrapper}>
        <Flex vertical id={id}>
          <Text>{t("message.title")}</Text>
          <Text>{t("message.link")}</Text>
          <Link href={url} target="_blank">
            {url}
          </Link>
          <Text>{t("message.expiration")}</Text>
        </Flex>
        <Flex>
          <CopyButton
            onCopy={() => {
              const element = document.getElementById(id)

              if (!element) return

              const text = element.innerText || element.textContent || ""

              navigator.clipboard.writeText(text)
            }}
          >
            {tGeneral("copy")}
          </CopyButton>
        </Flex>
      </Flex>
    </Flex>
  )
}
